import {
  Card,
  CardContent,
  Box,
  Typography,
  Chip,
  Divider,
} from "@mui/material";
import { PersonAdd } from "@mui/icons-material";

const GrowthMetricsCard = ({
  newUsersThisWeek,
  newUsersToday,
  newUsersThisMonth,
  tasksCreatedThisWeek,
  tasksCreatedToday,
  tasksCreatedThisMonth,
  avgVisitsPerUser,
}) => {
  return (
    <Card elevation={2}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PersonAdd color="secondary" sx={{ mr: 1 }} />
          <Typography variant="h6" fontWeight="bold">
            Growth Metrics
          </Typography>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            New Users
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              gap: 1,
              mb: 1,
              flexWrap: "wrap",
            }}
          >
            <Typography variant="h2" fontWeight="bold" color="secondary.main">
              {newUsersToday}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              today
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mx: 0.5 }}>
              •
            </Typography>
            <Typography variant="h5" fontWeight="bold" color="secondary.main">
              {newUsersThisWeek}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              this week
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mx: 0.5 }}>
              •
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="secondary.main">
              {newUsersThisMonth}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              this month
            </Typography>
          </Box>
          <Chip
            label={newUsersThisWeek > 0 ? "+Growth" : "Steady"}
            color={newUsersThisWeek > 0 ? "success" : "default"}
            size="small"
          />
        </Box>
        <Divider sx={{ my: 2 }} />
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Tasks Created
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              gap: 1,
              mb: 1,
              flexWrap: "wrap",
            }}
          >
            <Typography variant="h2" fontWeight="bold" color="warning.main">
              {tasksCreatedToday}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              today
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mx: 0.5 }}>
              •
            </Typography>
            <Typography variant="h5" fontWeight="bold" color="warning.main">
              {tasksCreatedThisWeek}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              this week
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mx: 0.5 }}>
              •
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="warning.main">
              {tasksCreatedThisMonth}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              this month
            </Typography>
          </Box>
          <Chip
            label={tasksCreatedThisWeek > 0 ? "+Active" : "Quiet"}
            color={tasksCreatedThisWeek > 0 ? "warning" : "default"}
            size="small"
          />
        </Box>
        <Divider sx={{ my: 2 }} />
        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            User Engagement
          </Typography>
          <Typography variant="h5" fontWeight="bold" color="primary.main">
            {avgVisitsPerUser} visits/user
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Average user engagement
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default GrowthMetricsCard;
